import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import axios from "axios";

// FIX: helper reads token at call-time, not at module-load time
// Prevents stale token after re-login without page reload
function getAuthHeaders() {
    const user = JSON.parse(localStorage.getItem("user"));
    return {
        Authorization: "Bearer " + user?.Token,
        Accept: "*/*",
    };
}

// API

export const getQuatationByUser = createAsyncThunk(
    "QuatationByUser/get",
    async (thunkAPI) => {
        let formData = new FormData();

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"getQuatationByUser",
                formData,
                {
                    headers: getAuthHeaders(),
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const getJRApprovalByUser = createAsyncThunk(
    "getJRApprovalByUser/get",
    async (thunkAPI) => {
        let formData = new FormData();
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"getJRApprovalByUser",
                formData,
                {
                    headers: getAuthHeaders(),
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const getJobRequestDetail = createAsyncThunk(
    "getJobRequestDetail/getEditDetail",
    async ({JRID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("JRID", JRID);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"getJobRequestDetail",
                formData,
                {
                    headers: getAuthHeaders(),
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const getJobRequestDetailUser = createAsyncThunk(
    "getJobRequestDetailUser/getDetail",
    async ({JRID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("JRID", JRID);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"getJobRequestDetailUser",
                formData,
                {
                    headers: getAuthHeaders(),
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);


export const getMJS = createAsyncThunk(
    "getMJS/getAl",
    async ({JRID}, thunkAPI) => {
        let formData = new FormData();

        formData.append("JRID", JRID);


        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"getMJS",
                {"JRID": JRID},
                {
                    headers: getAuthHeaders(),
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);


export const changeResponseSucess = createAsyncThunk(
    "getJobRequestDetailUser/changeResponseSucess",
    async () => {

        return {};
    }
);

export const getJobRequestDetailUnit = createAsyncThunk(
    "getJobRequestDetailUnit/getDetail",
    async ({JRID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("JRID", JRID);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"getJobRequestDetailUnit",
                formData,
                {
                    headers: getAuthHeaders(),
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const getJobRequestDetailActivity = createAsyncThunk(
    "getJobRequestDetailActivity/getDetail",
    async ({JRID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("JRID", JRID);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"getJobRequestDetailUserActivity",
                formData,
                {
                    headers: getAuthHeaders(),
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const insertJobRequestTransaksi = createAsyncThunk(
    "jobRequestTransaksi/insertJobRequestTransaksi",
    async (data, thunkAPI) => {
        // let formData = new FormData();
        // formData.append("QuatationNo", QuatationNo);
        // formData.append("SPKNo", SPKNo);
        // formData.append("Priority", Priority);
        // formData.append("Date", Date.toLocaleDateString("en-US"));
        // formData.append("Activity", Activity);

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"insertJobRequest",
                data,
                {
                    headers: getAuthHeaders(),
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const updateJobRequestTransaksi = createAsyncThunk(
    "jobRequestTransaksi/update",
    async (data, thunkAPI) => {
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"updateJobRequest",
                data,
                {
                    headers: getAuthHeaders(),
                }
            );
            if (response.status === 200) {

                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const updateShippingManifest = createAsyncThunk(
    "updateShippingManifest/update",
    async (data, ShippingManifestDetail, thunkAPI) => {
        try {
            let formData = new FormData();
            formData.append("ShippingManifest", data.ShippingManifest)
            formData.append("IncomingDate", data.IncomingDate)
            formData.append("JRID", data.JRID)
            formData.append("WSBNo", data.WSBNo)
            formData.append("SPKNo", data.SPKNo)

            for (var key in data.ShippingManifestDetail) {
                if(key != "SupportingFile")
                formData.append(key, data.ShippingManifestDetail[key]);
            }

            formData.append("SupportingFile", data.supportingFiles)

            const response = await axios.post(
                process.env.REACT_APP_API_URL+"updateShippingManifest",
                formData,
                {
                    headers: getAuthHeaders(),
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);


export const updateActivity = createAsyncThunk(
    "updateActivity/update",
    async (data, thunkAPI) => {
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"updateActivity",
                data,
                {
                    headers: getAuthHeaders(),
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const updatePremit = createAsyncThunk(
    "updatePremit/update",
    async (data, thunkAPI) => {
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"updatePermit",
                data,
                {
                    headers: getAuthHeaders(),
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const updatePermintaanUnit = createAsyncThunk(
    "updatePermintaanUnit/update",
    async (data, thunkAPI) => {
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"updatePermintaanUnit",
                data,
                {
                    headers: getAuthHeaders(),
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

//INIT
const initialState = {
    message: "",
    data: [],
    isKirimJobRequestFetching: false,
    isKirimJobRequestSuccess: false,
    isKirimJobRequestError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isGetAllFetching: false,
    isGetAllSuccess: false,
    isGetAllError: false,
    isGetDetailFetching: false,
    isGetDetailSuccess: false,
    isGetMJS: false,

    isGetDetailError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isGetEditDetailSuccess: false,
    isUpdateError: false,
    isDataDetailEdit: [],
    errorMessage: "",
    approvallist: [],
    isUpdateActivitySuccess: false,
    mjs: []
};

//SLICES
export const addJobRequestTransaksiSlice = createSlice({
    name: "quatationbyuser",
    initialState,
    reducers: {},
    extraReducers: {
        // GET
        [getQuatationByUser.rejected]: (state, {payload}) => {
            state.isKirimJobRequestFetching = false;
        },
        [getQuatationByUser.pending]: (state) => {
            state.isInsertSuccess = false

            state.isKirimJobRequestFetching = false;
        },

        [getQuatationByUser.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.isInsertSuccess = false
            state.data = payload.data;
            return state;
        },
        [changeResponseSucess.fulfilled]: (state, {payload}) => {
            state.isGetSuccess = false
            state.isGetDetailSuccess = false
            state.data = []
            return state;
        },


        [getJobRequestDetail.fulfilled]: (state, {payload}) => {
            state.isGetDetailFetching = false;
            state.isGetEditDetailSuccess = true;
            state.isUpdateSuccess = false;
            state.message = payload.message;
            state.isDataDetailEdit = payload.data;
            return state;
        },
        [getJobRequestDetail.rejected]: (state, {payload}) => {
            state.isGetDetailFetching = false;
            state.isGetDetailError = true;
            state.isUpdateSuccess = false;

            state.errorMessage = payload.message;
        },
        [getJobRequestDetail.pending]: (state) => {
            state.isGetDetailFetching = true;
            state.isUpdateSuccess = false;

        },

        [getJobRequestDetailUser.fulfilled]: (state, {payload}) => {
            state.isGetDetailFetching = false;
            state.isGetDetailSuccess = true;
            state.isUpdateSuccess = false;
            state.message = payload.message;
            state.dataDetail = payload.data;
            return state;
        },
        [getJobRequestDetailUser.rejected]: (state, {payload}) => {
            state.isGetDetailFetching = false;
            state.isGetDetailError = true;
            state.isUpdateSuccess = false;
            state.errorMessage = payload.message;
        },
        [getJobRequestDetailUser.pending]: (state) => {
            state.isUpdateSuccess = false;
            state.isGetDetailFetching = true;
        },
        [getMJS.fulfilled]: (state, {payload}) => {
            state.isGetMJS = true;
            state.isGetDetailFetching = false;

            state.message = payload.message;
            state.mjs = payload.data;
            return state;
        },
        [getMJS.rejected]: (state, {payload}) => {
            state.isGetDetailFetching = false;
            state.isGetDetailError = true;
            state.isUpdateSuccess = false;
            state.errorMessage = payload.message;
        },
        [getMJS.pending]: (state) => {
            state.isGetDetailFetching = true;
        },
        [getJobRequestDetailActivity.fulfilled]: (state, {payload}) => {
            state.isGetDetailFetching = false;
            state.isGetDetailSuccess = true;
            state.message = payload.message;
            state.dataDetail = payload.data;
            state.isUpdateActivitySuccess = false;
            return state;
        },
        [getJobRequestDetailActivity.rejected]: (state, {payload}) => {
            state.isGetDetailFetching = false;
            state.isGetDetailError = true;
            state.isUpdateActivitySuccess = false;

            state.errorMessage = payload.message;
        },
        [getJobRequestDetailActivity.pending]: (state) => {
            state.isGetDetailFetching = true;
            state.isUpdateActivitySuccess = false;

        },

        [getJobRequestDetailUnit.fulfilled]: (state, {payload}) => {
            state.isGetDetailFetching = false;
            state.isGetDetailSuccess = true;
            state.isUpdateSuccess = false;

            state.message = payload.message;
            state.dataDetail = payload.data;
            return state;
        },
        [getJobRequestDetailUnit.rejected]: (state, {payload}) => {
            state.isGetDetailFetching = false;
            state.isGetDetailError = true;
            state.isUpdateSuccess = false;

            state.errorMessage = payload.message;
        },
        [getJobRequestDetailUnit.pending]: (state) => {
            state.isGetDetailFetching = true;
            state.isUpdateSuccess = false;

        },

        // INSERT
        [insertJobRequestTransaksi.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            return state;
        },
        [insertJobRequestTransaksi.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            // state.errorMessage = payload.message;
        },
        [insertJobRequestTransaksi.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateJobRequestTransaksi.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            return state;
        },
        [updateJobRequestTransaksi.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateJobRequestTransaksi.pending]: (state) => {
            state.isUpdateFetching = true;
        },

        // UPDATE
        [updateShippingManifest.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            // window.location.reload(false);
            return state;
        },
        [updateShippingManifest.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.isUpdateSuccess = false
            // state.errorMessage = payload.message;
        },
        [updateShippingManifest.pending]: (state) => {
            state.isUpdateFetching = true;
        },
        [updateActivity.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateActivitySuccess = true;
            state.message = payload.message;
            // window.location.reload(false);
            return state;
        },
        [updateActivity.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateActivity.pending]: (state) => {
            state.isUpdateFetching = true;
        },

        // UPDATE
        [updatePremit.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            // window.location.reload(false);
            return state;
        },
        [updatePremit.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;

            state.errorMessage = payload.message;
        },
        [updatePremit.pending]: (state) => {
            state.isUpdateFetching = true;
        },

        // UPDATE
        [updatePermintaanUnit.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            // window.location.reload(false);
            return state;
        },
        [updatePermintaanUnit.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updatePermintaanUnit.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});

export const addJobRequestTransaksiSelector = (state) => state.quatationbyuser;
